import React, { useCallback } from "react";
import { connect } from "react-redux";
import FormField from '../../../../../dynamicFormBuilder/FormField';
import { PrimaryLayout } from '../Layout';

// Primary tab of the WM Crate Profile form (Delphi uWMD0064). Holds the profile block and the User
// Defined Codes block; the codes are WMCODES lookups configured in Layout.js, so there is no
// client-side option loading to do here.
function PrimaryTab(props) {
    var currentUser = props.oidc?.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;

    // FormField calls onFormLoad() unconditionally in a finally block with no default and no guard
    // (FormField.js:256), so it is a required prop even when there is nothing to load. The lookups on
    // this form fetch their own data, hence the no-op.
    const handleFormLoad = useCallback(() => {
    }, []);

    return (
        <div>
            <FormField
                currrentUser={currentUser}
                layoutId='0E9AB825-8D9C-45A9-9CF3-B160E180EAA3'
                layoutName='WMCrateProfilePrimaryForm'
                defaultFormSchema={PrimaryLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={props.handleFieldChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={props.formRefs}
                onFormLoad={handleFormLoad}
            />
        </div>
    );
}

function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}

export default connect(mapStateToProps)(PrimaryTab);
